export const guidanceList = [
  "alert-detail",
  "alert-list",
  "artist-home",
  "artist-detail",
  "audit-request-table",
  "banner-list",
  "banner-detail",
  "album-rank",
  "channel-detail",
  "email-editor",
  "email-templates",
  "event-consent-content-detail",
  "event-planning-table",
  "event-planning-detail",
  "default-event-consent-content",
  "fanclub-detail",
  "history-table",
  "history-detail",
  "inbound-list",
  "inbound-detail",
  "inbound-approve-table",
  "inbound-request-detail",
  "inbound-complete-table",
  "fan-club-event-detail",
  "supplier-table",
  "supplier-detail",
  "warehouse-table",
  "warehouse-detail",
  "warehouse-product-table",
  "warehouse-product-detail",
  "product-need-to-ship-table",
  "product-need-to-ship-detail",
  "notification-detail",
  "notification-list",
  "notice-table",
  "notice-detail",
  "package-detail",
  "package-table",
  "package-request-detail",
  "package-request-list",
  "shipment-completed-list",
  "shipment-requested-list",
  "package-review-detail",
  "package-review-list",
  "package-review-summary-table",
  "default-product-description-detail",
  "default-product-description-list",
  "qa-customer-table",
  "qa-page",
  "qa-order-table",
  "request-refund-detail",
  "request-refund-list",
  "request-purchase-list",
  "purchase-needed-list",
  "purchase-needed-detail",
  "files-table",
  "retail-detail",
  "retail-list",
  "service-fee-detail",
  "service-fee-table",
  "shippable-table",
  "shippable-approve-table",
  "shipping-fee-detail",
  "shipping-fee-table",
  "split-order-rule-table",
  "split-order-rule-detail",
  "shop-supplier-files-table",
  "shop-supplier-detail",
  "shop-supplier-table",
  "static-page-classification-detail",
  "static-page-classification-list",
  "static-page-detail",
  "static-page-list",
  "user-level-detail",
  "user-level-table",
  "product-list",
  "collection-list",
  "customer-list",
  "order-list",
  "user-list",
  "role-list",
  "permission-list",
  "channel-list",
  "administrator-detail",
  "administrator-list",
  "asset-detail",
  "asset-list",
  "collection-detail",
  "country-detail",
  "country-list",
  "customer-detail",
  "customer-group-list",
  "customer-group-detail",
  "draft-order-detail",
  "facet-detail",
  "facet-list",
  "global-setting-detail",
  "system-status",
  "job-list",
  "order-detail",
  "modify-order",
  "payment-method-detail",
  "payment-method-list",
  "product-detail",
  "product-variant-detail",
  "profile",
  "promotion-detail",
  "promotion-list",
  "role-detail",
  "seller-detail",
  "seller-list",
  "shipping-method-detail",
  "shipping-method-list",
  "stock-location-detail",
  "stock-location-list",
  "tax-category-detail",
  "tax-category-list",
  "tax-rate-detail",
  "tax-rate-list",
  "zone-detail",
  "zone-list",
  "push-template-list",
  "push-template-detail",
  "sms-templates",
];

export default guidanceList;
